const registry = new Map();
/** 新游戏零平台改动：games/* 调用它完成注册。 */
export function registerGame(opts) {
    if (registry.has(opts.manifest.id)) {
        console.warn(`[game-sdk] game "${opts.manifest.id}" re-registered, overwriting`);
    }
    registry.set(opts.manifest.id, opts);
}
export function getRegisteredGame(id) {
    return registry.get(id);
}
export function listRegisteredGames() {
    return [...registry.values()].map((g) => g.manifest);
}
//# sourceMappingURL=index.js.map